<script lang="ts" setup>
import { useQuery } from "@tanstack/vue-query";
import { useSettings } from "~/store/settings";
import { IEvent } from "~/types/sports/event";
import { IMarket } from "~/types/sports/market";
import { IOutcome } from "~/types/sports/outcome";
import { IPrice } from "~/types/sports/price";
import api from "~/utils/auth/api";
import SuperBoostEvent from "./SuperBoostEvent.vue";
import SuperBoostsLoadingSkeleton from "./SuperBoostsLoadingSkeleton.vue";

const settings = useSettings();

const {
	data: superBoosted,
	isLoading,
	error,
} = useQuery<{ markets: IMarket[]; outcomes: IOutcome[]; prices: IPrice[]; sportEvent: IEvent }[]>({
	queryKey: ["super-boost"],
	queryFn: () =>
		api({
			url: `/Feeds/SuperBoostedMarkets?countryCode=${settings.getCountryConfig?.countryIsoTwo}`,
			type: "sports",
			options: { method: "GET" },
		}),
});
</script>

<template>
	<div class="mb-6">
		<SuperBoostsLoadingSkeleton v-if="isLoading" />
		<SuperBoostEvent v-else v-for="boostedEvent of superBoosted" :boosted-event="boostedEvent" class="mb-4 px-4" />
	</div>
</template>
